import {BM_API_BASE_URL} from "../constants";

const SHOPPING_CART_URL_BASE = (cartId) => `${BM_API_BASE_URL}shopping_carts/${cartId || ''}`
const SHOPPING_CART_URL_EXECUTE = (cartId) => `${BM_API_BASE_URL}shopping_carts/${cartId}/execute/`

export {SHOPPING_CART_URL_BASE, SHOPPING_CART_URL_EXECUTE}